<template>
  <div class="wangEditor">
    <!-- <div>
        <button @click="insertText">insert text</button>
    </div> -->
    <div class="bjqnb"
         style="border: 1px solid #ccc">
      <!-- 工具栏 -->
      <Toolbar style="border-bottom: 1px solid #ccc"
               :editorId="editorId"
               :defaultConfig="toolbarConfig"
               :mode="mode" />

      <!-- 编辑器 -->
      <Editor :style="{height: height}"
              :editorId="editorId"
              :defaultConfig="editorConfig"
              :defaultContent="getDefaultContent"
              :mode="mode"
              @onCreated="onCreated"
              @onChange="onChange"
              @onDestroyed="onDestroyed"
              @onMaxLength="onMaxLength"
              @onFocus="onFocus"
              @onBlur="onBlur"
              @customAlert="customAlert"
              @customPaste="customPaste" />
    </div>
    <el-dialog width='500px'
               custom-class='viewBox'
               top='40px'
               title="预览"
               :visible.sync="dialogFormVisible">
      <div class="bgc">
        <div class="html"
             v-html="html"></div>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <!-- <el-button @click="dialogFormVisible = false">取 消</el-button> -->
        <el-button type="primary"
                   @click="dialogFormVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import website from "@/config/website";
import { getToken } from "@/utils/auth";
import Vue from "vue";
import "@wangeditor/editor/dist/css/style.css";
import { SlateEditor, SlateElement, SlateNode, SlateTransforms,DomEditor } from '@wangeditor/editor'
import { IButtonMenu, IDomEditor, t } from '@wangeditor/core'
import {
  Editor,
  Toolbar,
  getEditor,
  removeEditor,
} from "@wangeditor/editor-for-vue";
import { Transforms } from "slate";
import cloneDeep from "lodash.clonedeep";
import { Boot } from "@wangeditor/editor";
import withCtrlEnter from "./other/editorMenu.js";
import index from "./OfficialAccounts/index.js";
import RegistrationMenu from "./OfficialAccounts/RegistrationMenu.js";
import tohtml from "./OfficialAccounts/tohtml.js";
import withVideo from "./OfficialAccounts/withVideo.js";
import serveindex from "./serve/index.js";
import serveRegistrationMenu from "./serve/RegistrationMenu.js";
import servetohtml from "./serve/tohtml.js";
import servewithVideo from "./serve/withVideo.js";
import messageindex from "./message/index.js";
import messageRegistrationMenu from "./message/RegistrationMenu.js";
import messagetohtml from "./message/tohtml.js";
import messagewithVideo from "./message/withVideo.js";
import deleteVideoMenuConf from "./message/Deletemessage.js";
import deleteOfficialAccounts from "./OfficialAccounts/DeleteOfficialAccounts.js";
import DeleteServe from "./serve/DeleteServe.js";
// import menuConf from './cc.js'
Boot.registerPlugin(withCtrlEnter);
Boot.registerRenderElem(index);
Boot.registerMenu(RegistrationMenu);
Boot.registerElemToHtml(tohtml);
Boot.registerPlugin(withVideo);
Boot.registerRenderElem(serveindex);
Boot.registerMenu(serveRegistrationMenu);
Boot.registerElemToHtml(servetohtml);
Boot.registerPlugin(servewithVideo);
Boot.registerRenderElem(messageindex);
Boot.registerMenu(messageRegistrationMenu);
Boot.registerMenu(deleteVideoMenuConf);
Boot.registerMenu(deleteOfficialAccounts);
Boot.registerMenu(DeleteServe);
Boot.registerElemToHtml(messagetohtml);
Boot.registerPlugin(messagewithVideo);
import { unencrypt, encrypt } from '@/utils/encrypt';
export default {
  components: { Editor, Toolbar },
  props: {
    editorId: {
      // 组件唯一ID  必传并且全局不可重复
      type: String,
      default: "w-e-1",
    },
    height: {
      // 富文本框高度
      type: String,
      default: "700px",
    },
    contentStr: {
      // 富文本框高度
      type: String,
      default: "",
    },
    maxLength:{
      type: Number,
      default: null,
    },
    //超出长短提示
    maxLengthTS:{
      type: String,
      default: '超出长度限制',
    },
    defaultContent: {
      type: Array,
      default: () => {
        return [
          {
            type: "paragraph",
            children: [{ text: "" }],
          },
        ]
      }
    },
    excludeKeys: {
      type: Array,
      default: () => {
        return []
      }
    },
    showLine: Boolean, // 是否显示分割线
  },
  data () {
    return {
      // note: {
      //   backgroundImage: "url(" + require("../../../assets/iPhoneX.png") + ")",
      //   backgroundRepeat: "no-repeat",
      //   backgroundSize: "800px auto",
      //   backgroundOrigin:'0 0'
      //   // marginTop: "5px",
      // },
      dialogFormVisible: false,
      html: '',
      //【特别注意】
      // 1. editorId Toolbar 和 Editor 的关联，要保持一致
      // 2. 多个编辑器时，每个的 editorId 要唯一
      //   editorId: 'w-e-1',
      toolbarConfig: {
        excludeKeys:['uploadVideo']
      },
      editorConfig: {
        maxLength:'',
        placeholder: "请输入内容...",
        MENU_CONF: {
          uploadImage: {
            server: '/api/blade-workbench/eduSystemManageGuiseLogo/upload',
            fieldName: 'file',
            maxFileSize: 20 * 1024 * 1024, // 1M// 单个文件的最大体积限制，默认为 2M
            ase64LimitSize: 5 * 1024,// 5kb// 小于该值就插入 base64 格式（而不上传），默认为 0
            allowedFileTypes: ['image/*'],
            headers: {
              Authorization: `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`,
              'Blade-Auth': "bearer " + getToken()
            },
            meta: {
              fileType: '1',
              appName: ''
            },
            customInsert (res, insertFn) {
              console.log(res);
              console.log(insertFn);
              if (res.status == 1000) {
                console.log(data);
                let data =unencrypt(res.result)
                console.log(data);
                // res 即服务端的返回结果
                let url = data
                // 从 res 中找到 url alt href ，然后插图图片
                insertFn(url, '', '')
              } else {
                Vue.prototype.$message.error(res.msg)
              }

            },
            onError (file, err, res) {
              let str = err + ''
              if (str.indexOf('size') != -1) {
                Vue.prototype.$message.error('最大上传20M的图片')
              } else {
                Vue.prototype.$message.error('上传出错')
              }
            },
            onBeforeUpload (files) {
              let data = {}
              for (let key in files) {
                data = files[key]
              }
              console.log(files);
              console.log(files.extension);
              // let data = {...files}
              console.log(data);
              // files 选中的文件列表，格式如 { key1: file1, key2: file2 }
              return files

              // 返回值可选择：
              // 1. 返回一个对象（files 或者 files 的一部分），则将上传返回结果中的文件
              // 2. 返回 false ，终止上传
            },
          },
        },
        // 其他编辑器配置
        // 菜单配置
        hoverbarKeys: {
          message: {
            menuKeys: ['deletemessage'],
          },
          serve: {
            menuKeys: ['deleteServe'],
          },
          OfficialAccounts: {
            menuKeys: ['deleteOfficialAccounts'],
          },
          /* 工具栏配置 */
        },
      },
      mode: "default", // or 'simple'
      curContent: [],
    };
  },
  created(){
    console.log(this.maxLength);
    if (this.maxLength) {
      this.editorConfig.maxLength = this.maxLength
      console.log(this.maxLength);
    }
    if (this.excludeKeys.length>0) {
      this.toolbarConfig.excludeKeys = this.excludeKeys
    }
  },
  computed: {
    // 注意，深度拷贝 content ，否则会报错
    getDefaultContent () {
      return cloneDeep(this.defaultContent);
    },
  },

  methods: {
    async imgErr (img) {
      console.log(img);
      var ImgObj = await new Image();
      ImgObj.src = await img;
      console.log(ImgObj);
      console.log(ImgObj.fileSize);
      console.log(ImgObj.width);
      console.log(ImgObj.height);
      if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
        return img
      } else {
        return require('@/assets/zwx.png')
      }

    },
    reset (arr) {
      console.log(arr);
      const editor = getEditor(this.editorId);
      // 全选
      editor.select([])
      // 删除选中内容
      editor.deleteFragment()
      // 插入自己的内容
      SlateTransforms.insertNodes(editor, arr)
      // 删除第一个空行（按需）
      SlateTransforms.removeNodes(editor, { at: [0] })
    },
    isEmpty(){
      console.log();
      const editor = getEditor(this.editorId)
      // console.log(editor.isEmpty());
      console.log(editor.getAllMenuKeys());
      return editor.isEmpty()
    },
    removeServer () {
      console.log(1);
      const editor = getEditor(this.editorId);
      // 必须在最后添加一个p  要不然后面的标签删不掉
      SlateTransforms.insertNodes(editor, { type: 'paragraph', children: [{ text: '' }] })
      editor.selectAll()
      SlateTransforms.removeNodes(editor, {
        match: n => DomEditor.checkNodeType(n, 'serve'),
      })
      editor.deselect()
    },
    view () {
      const editor = getEditor(this.editorId);
      console.log(editor.getHtml());
      console.log(editor.children);
      console.log(editor);
      this.html = editor.getHtml()
      this.dialogFormVisible = true
      // this.$alert(editor.getHtml(), '预览', {
      //   dangerouslyUseHTMLString: true,
      //   customClass: 'viewBox'
      // });
    },
    crgzh (GZHCardData) {
      let a = GZHCardData.icon
      let b = GZHCardData.nickname
      let c = GZHCardData.accountSubject
      let d = GZHCardData.description
      let imId = GZHCardData.imId
      // let d = GZHCardData.accountSubject
      const editor = getEditor(this.editorId);
      // 还原选区
      editor.restoreSelection();

      // if (this.isDisabled(editor)) return;

      // 新建一个 video node
      const ccc = {
        type: "OfficialAccounts",
        a, b, c, d, imId,
        children: [{ text: "" }], // 【注意】void node 需要一个空 text 作为 children
      };

      // 插入视频
      // 不使用此方式会比正常的选区选取先执行
      Promise.resolve().then(() => {
        Transforms.insertNodes(editor, ccc);
      });
    },
    crfw (serveCardData) {
      console.log(serveCardData);
      let a = serveCardData.serviceUrl
      let b = serveCardData.serviceName
      let c = serveCardData.serviceIcon
      let accessWay = serveCardData.serviceType
      let id = serveCardData.id
      const editor = getEditor(this.editorId);
      // 还原选区
      editor.restoreSelection();

      // if (this.isDisabled(editor)) return;

      const ccc = {
        type: "serve",
        a, b, c, accessWay, id,
        children: [{ text: "" }], // 【注意】void node 需要一个空 text 作为 children
      };

      // 插入视频
      // 不使用此方式会比正常的选区选取先执行
      Promise.resolve().then(() => {
        Transforms.insertNodes(editor, ccc);
      });
    },
    async crgzhxx (item) {
      let a = item.title
      let b = item.content
      let c = item.imgUrl
      let d = item.redirectUrl
      let mpImId = item.mpImId
      let id = item.messageId
      console.log(c);
      const editor = await getEditor(this.editorId);
      // 还原选区
      await editor.restoreSelection();

      // if (this.isDisabled(editor)) return;

      // 新建一个 video node
      const ccc = {
        type: "message",
        a, b, c, d, mpImId, id,
        children: [{ text: "" }], // 【注意】void node 需要一个空 text 作为 children
      };

      // 插入视频
      // 不使用此方式会比正常的选区选取先执行
      await Promise.resolve().then(() => {
        Transforms.insertNodes(editor, ccc);
      });
    },
    onCreated (editor) {
      // console.log("onCreated", editor);、

    },
    onChange (editor) {
      const toolbar = DomEditor.getToolbar(editor)
      // console.log(toolbar);
      // console.log(DomEditor.getToolbar(editor));
      // console.log("onChange", editor.children);
      console.log(toolbar.getConfig().toolbarKeys);
      // console.log(Toolbar.getConfig().toolbarKeys);
      console.log(editor.getAllMenuKeys());
      this.curContent = editor.children;
      this.$emit('getHtmlList', editor.children)
      this.$emit('getContent', editor.getHtml(), editor.children)
    },
    onDestroyed (editor) {
      // console.log("onDestroyed", editor);
    },
    onMaxLength (editor) {
      console.log(1);
      // this.$message.error(this.maxLengthTS)
    },
    onFocus (editor) {
      // console.log("onFocus", editor);
    },
    onBlur (editor) {
      // console.log("onBlur", editor);
    },
    customAlert (info, type) {
      window.alert(`customAlert in Vue demo\n${type}:\n${info}`);
    },
    customPaste (editor, event, callback) {
      // console.log("ClipboardEvent 粘贴事件对象", event);

      // 自定义插入内容
      // editor.insertText('xxx')

      // 返回值（注意，vue 事件的返回值，不能用 return）
      // callback(false) // 返回 false ，阻止默认粘贴行为
      callback(true); // 返回 true ，继续默认的粘贴行为
    },

    // insertText() {
    //     // 获取 editor 实例，即可执行 editor API
    //     const editor = getEditor(this.editorId)
    //     if (editor == null) return
    //     if (editor.selection == null) return

    //     // 在选区插入一段文字
    //     editor.insertText('一段文字')
    // },
  },

  // 及时销毁 editor
  beforeDestroy () {
    const editor = getEditor(this.editorId);
    if (editor == null) return;

    // 销毁，并移除 editor
    editor.destroy();
    removeEditor(this.editorId);
  },
};
</script>

<style lang="scss">
@import "@/styles/wangEditor/index.scss";
.wangEditor {
  font-size: 12px;
  p {
    margin: 0 !important;
  }
  // a{
  //   color: #096dd9;
  // }
}
.cardBox {
  width: 500px;
  height: 800px;
  .el-message-box__content {
    height: 700px;
    white-space: pre-wrap;
  }
}

.bjq {
  display: flex;
  overflow: scroll;
}
</style>
